import React from "react";
import { Box, Grid } from "@mui/material";
import { useWidth } from "../../../../../libs/hooks";
import { ConfigProvider, Segmented } from "antd";
import { COLOR_PRIMARY } from "../../../../../libs/constants";
import { PERIOD_OPTIONS, PeriodKey, periodLabel } from "./period";
// import {
//   message,
// } from "antd";
import {
  CarOutlined,
  ContainerOutlined,
  InboxOutlined,
  SafetyCertificateOutlined,
} from "@ant-design/icons";
import { CardComponent } from "./card-component";
import { TableComponent } from "./table-component";
import {
  workflowContainerCheckPointCount,
  workflowContainerEmptyCount,
  workflowContainerFullCount,
  workflowTruckCount,
} from "../../../../../libs/apis";

export const AdministratorComponent = ({ options }: { options: any[] }) => {
  const width = useWidth();
  const [period, setPeriod] = React.useState<PeriodKey>("hoy");
  const [totalEmpty, setTotalEmpty] = React.useState(0);
  const [totalFull, setTotalFull] = React.useState(0);
  const [totalCheck, setTotalCheck] = React.useState(0);
  const [totalTruck, setTotalTruck] = React.useState(0);

  React.useEffect(() => {
    let active = true;
    const load = async (
      fn: (value: string) => Promise<{ data?: { total: number } | null }>,
      set: (total: number) => void
    ) => {
      try {
        const { data } = await fn(period);
        if (active && data) set(data.total);
      } catch (err: any) {
        console.log(err.toString());
      }
    };

    load(workflowContainerEmptyCount, setTotalEmpty);
    load(workflowContainerFullCount, setTotalFull);
    load(workflowContainerCheckPointCount, setTotalCheck);
    load(workflowTruckCount, setTotalTruck);

    return () => {
      active = false;
    };
  }, [period]);

  const label = periodLabel(period);

  return (
    <Box
      sx={{
        p: 1,
        height: "100%",
        minHeight: "100%",
        maxHeight: "100%",
        overflowY: "auto",
      }}
    >
      <Grid container spacing={2} justifyContent="center">
        <Grid item xs={12}>
          <Box sx={{ display: "flex", justifyContent: "center" }}>
            <ConfigProvider theme={{ token: { colorPrimary: COLOR_PRIMARY } }}>
              <Segmented
                block={width === "xs"}
                value={period}
                onChange={(value) => setPeriod(value as PeriodKey)}
                options={PERIOD_OPTIONS}
                style={{
                  boxShadow: "0 1px 4px rgba(30, 58, 95, 0.18)",
                  maxWidth: "100%",
                }}
              />
            </ConfigProvider>
          </Box>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <CardComponent
            width={width}
            title="Contendedores Vacíos"
            quantity={totalEmpty}
            color="#F4623A"
            icon={<InboxOutlined />}
            periodLabel={label}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <CardComponent
            width={width}
            title="Contendedores Full"
            quantity={totalFull}
            color="#F59E0B"
            icon={<ContainerOutlined />}
            periodLabel={label}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <CardComponent
            width={width}
            title="CheckPoint"
            quantity={totalCheck}
            color="#22A745"
            icon={<SafetyCertificateOutlined />}
            periodLabel={label}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <CardComponent
            width={width}
            title="Camión"
            quantity={totalTruck}
            color="#1677FF"
            icon={<CarOutlined />}
            periodLabel={label}
          />
        </Grid>
        <Grid item xs={12}>
          <TableComponent period={period} />
        </Grid>
      </Grid>
    </Box>
  );
};
